import {
    EVENT_ASSOCIATE_URL,
    EVENT_FORMAT_URL,
    EVENT_STATUS_URL,
    EVENT_TYPE_URL,
    FAMILY_USERS,
    MILESTONE_DATA,
    MLT_USERS,
    SITE_DETAILS_URL,
    SITE_EVENT_DETAILS_UPDATED
} from "../ApiDetails.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Header from "../HeaderAdmin.js";
import Navbar from "../Navbar.js";
import Submenu from "../Submenu.js";
import DonutChartAnniversary from "./DonutChartAnniversary.js";
import StackedBarChart from "./StackedBarChartSite.jsx";
import "./siteReport.css";

const siteReport = () => {
    const [reportsData, setReportsData] = useState([]);
    const [milestoneResponse, setMilestoneResponse] = useState([]);
    const [stackedBarGraphData, setStackedBarGraphData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const pagesToShow = 4;
    const [isLoading, setIsLoading] = useState(false);
    const [donutChartData, setDonutChartData] = useState([]);
    const [assoSegment, setAssoSegment] = useState([]);
    const [siteCodes, setSiteCodes] = useState([]);
    const [famMem, setFamMem] = useState([]);
    const [eventStatusFilters, setEventStatusFilters] = useState([]);
    const [eventTypeFilters, setEventTypeFilters] = useState([]);
    const [eventFormatFilters, setEventFormatFilters] = useState([]);
    const [mltUserMembers, setMltUserMembers] = useState([]);
    const [navBarMltValue, setNavBarMltValue] = useState(false);

    const [reportsFilter, setReportsFilter] = useState({
        associateSegment: "All",
        location: "All",
        type: "All",
        format: "All",
        status: "All",
        familyMember: "All",
        selectedmltMem: "All",
        milestone: "All",
        startYear: 2024,
        endYear: 2027,
        associateHeadCountFrom: 0,
        associateHeadCountTo: 0,
        reRender: "no",
    });

    const element = document.getElementById("navBarMltValue");
    if (element) {
        element.addEventListener("change", () => {
            setNavBarMltValue(element.checked);
        });
    }

    // Fetch Assosiate Segments
    useEffect(() => {
        const mltUserMember = async () => {
            try {
                const response = await axios.get(MLT_USERS);
                setMltUserMembers(response.data);
            } catch (error) {
                console.error("Error fetching mlt members:", error);
            }
        };
        mltUserMember();
    }, []);

    useEffect(() => {
        const fetchAssociateSegment = async () => {
            try {
                const response = await axios.get(EVENT_ASSOCIATE_URL);
                setAssoSegment(response.data);
            } catch (error) {
                console.error("Error fetching segment:", error);
            }
        };
        fetchAssociateSegment();
    }, []);

    // Fetch Site Locations
    useEffect(() => {
        const fetchSiteLocations = async () => {
            try {
                const response = await axios.get(SITE_DETAILS_URL);

                const siteData = response.data
                    .map((site) => ({
                        name: (site.site_code + " - " + site.unit) || "Unknown",
                        lat: site.latitude ? parseFloat(site.latitude) : null,
                        lng: site.longitude ? parseFloat(site.longitude) : null,
                    }))
                    .filter((site) => site.lat !== null && site.lng !== null)
                    .sort((a, b) => a.name.localeCompare(b.name));

                setSiteCodes(siteData);
            } catch (error) {
                console.error("Error fetching site locations:", error);
            }
        };

        fetchSiteLocations();
    }, []);

    // Fetch Family Members
    useEffect(() => {
        const fetchFamilyMembers = async () => {
            try {
                const response = await axios.get(FAMILY_USERS);
                setFamMem(response.data);
            } catch (error) {
                console.error("Error fetching family members:", error);
            }
        };
        fetchFamilyMembers();
    }, []);

    //Fetch Event Type
    useEffect(() => {
        const fetchEventTypeFilter = async () => {
            try {
                const response = await axios.get(EVENT_TYPE_URL);
                setEventTypeFilters(response.data);
            } catch (error) {
                console.error("Error fetching event type filters:", error);
            }
        };

        fetchEventTypeFilter();
    }, []);

    //Fetch Event Status
    useEffect(() => {
        const fetchEventStatusFilter = async () => {
            try {
                const response = await axios.get(EVENT_STATUS_URL);
                setEventStatusFilters(response.data);
            } catch (error) {
                console.error("Error fetching event status filters:", error);
            }
        };

        fetchEventStatusFilter();
    }, []);

    //Event Format
    useEffect(() => {
        const fetchEventFormatFilter = async () => {
            try {
                const response = await axios.get(EVENT_FORMAT_URL);
                setEventFormatFilters(response.data);
            } catch (error) {
                console.error("Error fetching event format filters:", error);
            }
        };

        fetchEventFormatFilter();
    }, []);


    useEffect(() => {
        const initialFetch = async () => {
            try {
                const {
                    startYear,
                    endYear,
                } = reportsFilter;

                // Initialize URLSearchParams objects
                const siteEventParams = new URLSearchParams();
                const milestoneParams = new URLSearchParams();

                if (startYear) {
                    milestoneParams.append("StartDate", startYear);
                    siteEventParams.append("StartDate", startYear);

                }

                if (endYear) {
                    milestoneParams.append("EndDate", endYear);
                    siteEventParams.append("EndDate", endYear);
                }

                siteEventParams.append("MLTSwitch", navBarMltValue);
                milestoneParams.append("MLTSwitch", navBarMltValue);

                // Construct the full API URLs with the query parameters
                const apiUrl = `${SITE_EVENT_DETAILS_UPDATED}${siteEventParams.toString() ? `?${siteEventParams.toString()}` : ''}`;
                const apiUrlMilestone = `${MILESTONE_DATA}${milestoneParams.toString() ? `?${milestoneParams.toString()}` : ''}`;

                // Make the API requests
                const response = await axios.get(apiUrl);
                const milestoneResponse = await axios.get(apiUrlMilestone);

                // Update the state with the response data
                setReportsData(response.data);
                setMilestoneResponse(milestoneResponse.data);

            } catch (error) {
                console.error("Error fetching initial data:", error);
            }
        };

        initialFetch();
    }, [reportsFilter.reRender, navBarMltValue]);


    // Handle Apply Filter Click
    const handleApplyFilterClick = async () => {
        setIsLoading(true);

        try {
            const {
                associateSegment,
                location,
                type,
                format,
                status,
                familyMember,
                selectedmltMem,
                milestone,
                startYear,
                endYear,
                associateHeadCountFrom,
                associateHeadCountTo,
            } = reportsFilter;

            // Initialize URLSearchParams objects
            const siteEventParams = new URLSearchParams();
            const milestoneParams = new URLSearchParams();

            // Append parameters for both APIs
            if (associateSegment && associateSegment !== "All") {
                siteEventParams.append("Segment", associateSegment);
                milestoneParams.append("Segment", associateSegment);
            }

            if (location && location !== "All") {
                milestoneParams.append("Location", location.split(" ")[0]);
                siteEventParams.append("location", location.split(" ")[0]);
            }

            if (type && type !== "All") {
                siteEventParams.append("Type", type);
                milestoneParams.append("Type", type);
            }

            if (format && format !== "All") {
                siteEventParams.append("Format", format);
                milestoneParams.append("Format", format);
            }

            if (status && status !== "All") {
                siteEventParams.append("Status", status);
                milestoneParams.append("Status", status);
            }

            if (navBarMltValue) {
                if (selectedmltMem && selectedmltMem !== "All") {
                    siteEventParams.append("Member", selectedmltMem);
                    milestoneParams.append("Member", selectedmltMem);
                }
            } else {
                if (familyMember && familyMember !== "All") {
                    siteEventParams.append("Member", familyMember);
                    milestoneParams.append("Member", familyMember);
                }
            }

            if (milestone && milestone !== "All") {
                siteEventParams.append("Milestone", milestone);
                milestoneParams.append("Milestone", milestone);
            }

            if (startYear) {
                siteEventParams.append("StartDate", startYear);
                milestoneParams.append("StartDate", startYear);
            }

            if (endYear) {
                siteEventParams.append("EndDate", endYear);
                milestoneParams.append("EndDate", endYear);
            }

            if (startYear) {
                milestoneParams.append("StartDate", startYear);
                siteEventParams.append("StartDate", startYear);
            }

            if (endYear) {
                milestoneParams.append("EndDate", endYear);
                siteEventParams.append("EndDate", endYear);
            }

            if (associateHeadCountFrom && associateHeadCountFrom !== 0) {
                siteEventParams.append("FromHeadCount", associateHeadCountFrom);
                milestoneParams.append("FromHeadCount", associateHeadCountFrom);
            }

            if (associateHeadCountTo && associateHeadCountTo !== 0) {
                siteEventParams.append("ToHeadCount", associateHeadCountTo);
                milestoneParams.append("ToHeadCount", associateHeadCountTo);
            }

            siteEventParams.append("MLTSwitch", navBarMltValue);
            milestoneParams.append("MLTSwitch", navBarMltValue);


            // Construct the full API URLs with the query parameters
            const apiUrl = `${SITE_EVENT_DETAILS_UPDATED}${siteEventParams.toString() ? `?${siteEventParams.toString()}` : ''}`;
            const apiUrlMilestone = `${MILESTONE_DATA}${milestoneParams.toString() ? `?${milestoneParams.toString()}` : ''}`;

            // Make the API requests
            const response = await axios.get(apiUrl);
            const milestoneResponse = await axios.get(apiUrlMilestone);

            // Update the state with the response data
            setReportsData(response.data);
            setMilestoneResponse(milestoneResponse.data);
            paginate(1);
        } catch (error) {
            console.error("Error fetching filtered site event details:", error);
        } finally {
            setIsLoading(false); // Set loading to false after the fetch is complete
        }

    };

    // Handle Clear All Filters
    const handleClearAllFilters = () => {
        setReportsFilter((prevState) => ({
            ...prevState,
            associateSegment: "All",
            location: "All",
            type: "All",
            format: "All",
            status: "All",
            familyMember: "All",
            selectedmltMem: "All",
            milestone: "All",
            startYear: 2024,
            endYear: 2027,
            associateHeadCountFrom: 0,
            associateHeadCountTo: 0,

            reRender: prevState.reRender === "yes" ? "no" : "yes", // Toggle reRender value
        }));
        setReportsData([]);
        paginate(1);
    };


    // Pagination logic
    const totalPages = Math.ceil(reportsData.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = reportsData.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => {
        if (pageNumber < 1) {
            pageNumber = 1;
        } else if (pageNumber > totalPages) {
            pageNumber = totalPages;
        }
        setCurrentPage(pageNumber);
    };

    const pageNumbers = [];
    for (
        let i = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
        i <= Math.min(totalPages, currentPage + Math.floor(pagesToShow / 2));
        i++
    ) {
        pageNumbers.push(i);
    }

    useEffect(() => {

        const milestoneCounts = {};

        // Calculate milestone counts and total count
        milestoneResponse.forEach(({ milestone, milestoneCount }) => {
            milestoneCounts[milestone] = (milestoneCounts[milestone] || 0) + milestoneCount;
        });

        // Pass raw counts to the Donut Chart
        const processedData = {};
        Object.keys(milestoneCounts).forEach((milestone) => {
            processedData[`${milestone} Years`] = milestoneCounts[milestone]; // Keep counts
        });

        // Update state with processed data for the Donut chart
        setDonutChartData(processedData);

    }, [milestoneResponse]);



    useEffect(() => {
        const processedData = milestoneResponse.reduce((acc, item) => {
            const { anniversary_Year, milestone, milestoneCount } = item;

            // Initialize the year entry if it doesn't exist
            if (!acc[anniversary_Year]) {
                acc[anniversary_Year] = { x: anniversary_Year };
            }

            // Set milestone counts for the year
            acc[anniversary_Year][milestone] = milestoneCount;

            return acc;
        }, {});

        // Convert object to array for the stacked bar graph format
        setStackedBarGraphData(Object.values(processedData));
    }, [milestoneResponse]);

    return (
        <div>
            <Header />
            <div
                className="reportsContainerPadding"
            >
                <Navbar />
                <div className="single-card-container">
                    <div className="cards submenuContainer">
                        <Submenu reportsData={reportsData} />
                    </div>
                </div>

                <div
                    style={{
                        filter: isLoading ? "blur(2px)" : "none",
                        transition: "filter 0.3s ease",
                    }}
                >
                    <div className="single-card-container filter">
                        <div className="cards">
                            <div className="row">
                                <div className="d-flex bd-highlight eventReportFiltersContainer align-items-center">
                                    <div className="flex-fill bd-highlight text-center">
                                        <h3 className="reportTitle">FILTERS</h3>
                                    </div>
                                    <div className="p-2 col-10 d-flex align-content-start flex-wrap">
                                        <div className="col-12">
                                            <div className="row eventReportFiltersSpacing">
                                                <div className="col">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom"
                                                            htmlFor="associateSegment"
                                                        >
                                                            Associate&apos;s Segment
                                                        </label>
                                                        <select
                                                            className="form-control-custom rounded form-select"
                                                            aria-label="Associate's Segment"
                                                            id="associateSegment"
                                                            value={reportsFilter.associateSegment}
                                                            onChange={(e) => {
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    associateSegment: e.target.value,
                                                                });
                                                            }}
                                                        >
                                                            <option value="All">All</option>
                                                            {assoSegment.length > 0 &&
                                                                assoSegment.map((asso, index) => (
                                                                    <option key={index} value={asso}>
                                                                        {asso}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom"
                                                            htmlFor="site"
                                                        >
                                                            Site Code
                                                        </label>
                                                        <select
                                                            className="form-control-custom rounded form-select"
                                                            aria-label="Site"
                                                            id="site"
                                                            value={reportsFilter.location}
                                                            onChange={(e) => {
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    location: e.target.value,
                                                                });
                                                            }}
                                                        >
                                                            <option value="All">All</option>
                                                            {siteCodes.length > 0 &&
                                                                siteCodes.map((site, index) => (
                                                                    <option key={index} value={site.name}>
                                                                        {site.name}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom"
                                                            htmlFor="type"
                                                        >
                                                            Type
                                                        </label>
                                                        <select
                                                            className="form-control-custom rounded form-select"
                                                            aria-label="Type"
                                                            id="type"
                                                            value={reportsFilter.type}
                                                            onChange={(e) => {
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    type: e.target.value,
                                                                });
                                                            }}
                                                        >
                                                            <option value="All">All</option>
                                                            {eventTypeFilters.length > 0 &&
                                                                eventTypeFilters.map((eventType, index) => (
                                                                    <option key={index} value={eventType}>
                                                                        {eventType}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom"
                                                            htmlFor="format"
                                                        >
                                                            Format
                                                        </label>
                                                        <select
                                                            className="form-control-custom rounded form-select"
                                                            aria-label="Format"
                                                            id="format"
                                                            value={reportsFilter.format}
                                                            onChange={(e) => {
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    format: e.target.value,
                                                                });
                                                            }}
                                                        >
                                                            <option value="All">All</option>
                                                            {eventFormatFilters.length > 0 &&
                                                                eventFormatFilters.map((format, index) => (
                                                                    <option key={index} value={format}>
                                                                        {format}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="row mt-4 eventReportFiltersSpacing">
                                                <div className="col">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom"
                                                            htmlFor={navBarMltValue ? "mltMem" : "famMem"}
                                                        >
                                                            {navBarMltValue ? "MLT MEMBERS" : "FAMILY MEMBERS"}
                                                        </label>
                                                        <select
                                                            className="form-control-custom rounded form-select"
                                                            aria-label={navBarMltValue ? "mltMem" : "famMem"}
                                                            id={navBarMltValue ? "mltMem" : "famMem"}
                                                            value={
                                                                navBarMltValue
                                                                    ? reportsFilter.selectedmltMem
                                                                    : reportsFilter.familyMember
                                                            } // Corrected value binding
                                                            onChange={(e) => {
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    [navBarMltValue ? "selectedmltMem" : "familyMember"]: e.target.value, // Corrected state update
                                                                });
                                                            }}
                                                        >
                                                            <option value="All">All</option>
                                                            {(navBarMltValue ? mltUserMembers : famMem).map((memName, index) => (
                                                                // TODO: Switch to user.ID if possible.
                                                                <option key={index} value={memName.fullname}>
                                                                    {memName.fullname}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom"
                                                            htmlFor="status"
                                                        >
                                                            Status
                                                        </label>
                                                        <select
                                                            className="form-control-custom rounded form-select"
                                                            aria-label="Status"
                                                            id="status"
                                                            value={reportsFilter.status}
                                                            onChange={(e) => {
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    status: e.target.value,
                                                                });
                                                            }}
                                                        >
                                                            <option value="All">All</option>
                                                            {eventStatusFilters.length > 0 &&
                                                                eventStatusFilters.map((status, index) => (
                                                                    <option key={index} value={status}>
                                                                        {status}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom"
                                                            htmlFor="milestone"
                                                        >
                                                            Milestones
                                                        </label>
                                                        <select
                                                            className="form-control-custom rounded form-select"
                                                            aria-label="Milestone"
                                                            id="milestone"
                                                            value={reportsFilter.milestone}
                                                            onChange={(e) => {
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    milestone: e.target.value,
                                                                });
                                                            }}
                                                        >
                                                            <option value="All">All</option>
                                                            <option value="10">10 years</option>
                                                            <option value="15">15 years</option>
                                                            <option value="20">20 years</option>
                                                            <option value="25">25 years</option>
                                                            <option value="30">30 years</option>
                                                            <option value="35">35 years</option>
                                                            <option value="40">40 years</option>
                                                            <option value="45">45 years</option>
                                                            <option value="50">50 years</option>
                                                            <option value="55">55 years</option>
                                                            <option value="60">60 years</option>
                                                            <option value="65">65 years</option>
                                                            <option value="70">70 years</option>
                                                            <option value="75">75 years</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="row mt-4 eventReportFiltersSpacing">
                                                <div className="col">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom"
                                                            htmlFor="startYear"
                                                        >
                                                            START YEAR
                                                        </label>
                                                        <input
                                                            type="number"
                                                            className="form-control-custom rounded form-select"
                                                            id="startYear"
                                                            value={reportsFilter.startYear}
                                                            onChange={(e) =>
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    startYear: parseInt(e.target.value, 10),
                                                                })
                                                            }
                                                            placeholder="Start Year"
                                                            max="2100"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom"
                                                            htmlFor="endYear"
                                                        >
                                                            END YEAR
                                                        </label>
                                                        <input
                                                            type="number"
                                                            className="form-control-custom rounded form-select"
                                                            id="endYear"
                                                            value={reportsFilter.endYear}
                                                            onChange={(e) =>
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    endYear: parseInt(e.target.value, 10),
                                                                })
                                                            }
                                                            placeholder="End Year"
                                                            max="2100"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="input-group mb-0">
                                                        <label
                                                            className="input-group-text input-group-text-custom"
                                                            htmlFor="associateHeadCountFrom"
                                                        >
                                                            Associate Head Count
                                                        </label>
                                                        <input
                                                            type="number"
                                                            className="form-control-custom rounded form-select"
                                                            id="associateHeadCountFrom"
                                                            value={reportsFilter.associateHeadCountFrom}
                                                            placeholder="0"
                                                            onChange={(e) => {
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    associateHeadCountFrom: e.target.value,
                                                                });
                                                            }}
                                                            max="2100"
                                                            min="0"
                                                        />
                                                        <label
                                                            className="input-group-text input-group-text-custom"
                                                        >
                                                            To
                                                        </label>
                                                        <input
                                                            type="number"
                                                            className="form-control-custom rounded form-select"
                                                            id="associateHeadCountTo"
                                                            value={reportsFilter.associateHeadCountTo || ""}
                                                            onChange={(e) => {
                                                                setReportsFilter({
                                                                    ...reportsFilter,
                                                                    associateHeadCountTo: e.target.value,
                                                                });
                                                            }}
                                                            placeholder="MAX"
                                                            max="2100"
                                                            min="0"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-1 text-end d-flex flex-column align-items-end justify-content-center eventReportsFiltersButtons">
                                        <button
                                            className="btn-primary-custom p-1 mt-2"
                                            onClick={handleApplyFilterClick}
                                        >
                                            Apply Filters
                                        </button>
                                        <button
                                            className="btn-secondary-custom"
                                            onClick={handleClearAllFilters}
                                        >
                                            Clear All
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Display filtered results, charts, pagination, etc. */}
                    {/* New container for the charts */}
                    <div className="card-container">
                        {/* Donut Chart */}
                        <div className="cards">
                            <div className="card-header">ANNIVERSARIES</div>
                            <DonutChartAnniversary anniversaryData={donutChartData} />
                        </div>

                        {/* Bar Chart */}
                        <div className="cards">
                            <div className="card-header">MILESTONE DATA</div>
                            <StackedBarChart data={stackedBarGraphData} />
                        </div>
                    </div>
                    {/* Table for displaying report data */}
                    <div className="single-card-container">
                        <div className="cards-table">
                            <div className="grid-container-sites">
                                <div className="grid-header-first">SITE CODE</div>
                                <div className="grid-header">BUSINESS UNIT</div>
                                <div className="grid-header">OPENING DATE</div>
                                <div className="grid-header">LAST VISIT DATE</div>
                                <div className="grid-header">LOCATION</div>
                                <div className="grid-header">EVENT</div>
                                <div className="grid-header">FAMILY MEMBER</div>
                                <div className="grid-header-last">ASSOCIATE HEAD COUNT</div>
                                {/* <div className="grid-header">SEE EVENTS</div> */}

                                {currentItems.length > 0 ? (
                                    currentItems.map((item, index) => (
                                        <React.Fragment key={index}>
                                            <div className="grid-item-first">{item.sitecode}</div>
                                            <div className="grid-item">{item.unit}</div>
                                            <div className="grid-item">{item.move_in_date ? new Date(item.move_in_date).toLocaleDateString('en-US', {timeZone: 'UTC'}) : ""}</div>
                                            <div className="grid-item">{item.lastVisitDate ? new Date(item.lastVisitDate).toLocaleDateString('en-US', {timeZone: 'UTC'}) : ""}</div>
                                            <div className="grid-item">{item.location}</div>
                                            <div className="grid-item">{item.eventCount}</div>
                                            <div className="grid-item">{item.familyMemCount}</div>
                                            <div className="grid-item-last">{item.associateHeadCount}</div>


                                            {/* <div className="grid-item-last">
                        <button
                          className="btn btn-icon"
                          onClick={() => handleEventview(item)}
                        >
                          <img
                            src={view}
                            alt="Edit"
                            width={24}
                            height={24}
                          />
                        </button>
                      </div> */}
                                        </React.Fragment>
                                    ))
                                ) : (
                                    <div
                                        className="grid-item"
                                        style={{ gridColumn: "1 / -1", textAlign: "center" }}
                                    >
                                        No events found
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {/* Pagination */}
                    <nav aria-label="Page navigation">
                        <ul className="pagination-report justify-content-center">
                            <li className={`page-item-report ${currentPage === 1 ? "disabled-report" : ""}`}>
                                <button
                                    className="page-link-report"
                                    onClick={() => paginate(currentPage - 1)}
                                >
                                    Previous
                                </button>
                            </li>
                            {pageNumbers.map((number) => (
                                <li
                                    key={number}
                                    className={`page-item-report ${number === currentPage ? "active-report" : ""}`}
                                >
                                    <button onClick={() => paginate(number)} className="page-link-report">
                                        {number}
                                    </button>
                                </li>
                            ))}
                            <li
                                className={`page-item-report ${currentPage === totalPages ? "disabled-report" : ""}`}
                            >
                                <button
                                    className="page-link-report"
                                    onClick={() => paginate(currentPage + 1)}
                                >
                                    Next
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    );
};

export default siteReport;
